import "./service.css"
import services from "../../assets/services"
import { useTranslation } from "react-i18next";

const Service = () => {
  const { t } = useTranslation();
  return (
    <>
    {services.map((service, index) => (
    <div className="service-container" key={index}>

        <div className="service-icon">
            <img src={service.image} alt={t(`services.items.${index}.alt`)} />
        </div>

        <div className="service-head">
            <h5>{t(`services.items.${index}.name`)}</h5>
        </div>

        <div className="service-body">
            <p>{t(`services.items.${index}.body`)}</p>
        </div>

    </div>
    ))}
    </>
  )
}

export default Service